var validateStationPhoneNo = (rule, value, callback) => {
  if (!/^([0-9]{11}|[0-9]{13})$/.test(value)) {
    callback(new Error("只能输入0-9之间的数字,且长度只能为11位或13位,当前已输入" + value.length + "位"));
  } else {
    callback();
  }
};
var validatePhoneNo = (rule, value, callback) => {
  if (!/^([0-9]{11})$/.test(value)) {
    callback(new Error("只能输入0-9之间的数字,且长度只能为11位,当前已输入" + value.length + "位"));
  } else {
    callback();
  }
};

var validateOnlyNumberGreateZero = (rule, value, callback) => {
  if (!/^([0-9]{1,})$/.test(value)) {
    callback(new Error("只能输入大于或等于0的数字"));
  } else {
    callback();
  }
};

var validateTextLength = (rule, value, callback) => {
  if (value && value.length > 80) {
    callback(new Error("最多只能输入80个字符"));
  } else {
    callback();
  }
};

export const RULES = {
  projectStationAlarmInterval: [
    { required: true, message: "该项为必填项", trigger: "blur" },
    { validator: validateOnlyNumberGreateZero, trigger: "blur" }
  ],
  projectStationAlarmEnable: [
    { required: true, message: "该项为必填项", trigger: "blur" }
  ],
  projectStationId: [
    { required: true, message: "该项为必填项", trigger: "blur" }
  ],
  projectStationName: [
    { required: true, message: "该项为必填项", trigger: "blur" }
  ],
  projectStationEnable: [
    { required: true, message: "该项为必填项", trigger: "change" }
  ],
  projectStationManagerPhone: [
    { required: true, message: "该项为必填项", trigger: "blur" },
    { validator: validatePhoneNo, trigger: "blur" }
  ],
  projectStationInterval: [
    { required: true, message: "该项为必填项", trigger: "blur" },
    { validator: validateOnlyNumberGreateZero, trigger: "blur" }
  ],
  projectStationChannelCount: [
    { required: true, message: "该项为必填项", trigger: "blur" }
  ],
  projectStationLatLng: [
    { required: true, message: "该项为必填项", trigger: ["blur", "change"] }
  ],
  projectStationPhone: [
    { required: true, message: "该项为必填项", trigger: "blur" },
    { validator: validateStationPhoneNo, trigger: "blur" }
  ],
  projectStationComment: [
    { validator: validateTextLength, trigger: "blur" }
  ]
};
